import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=572a462b&scoped=true"
import script from "./UserDetail.vue?vue&type=script&lang=js"
export * from "./UserDetail.vue?vue&type=script&lang=js"
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=572a462b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a462b",
  null
  
)

export default component.exports